import {
  inviteSchema,
  InviteSchema,
} from '@soniq/schema-connection'
import {
  HttpReadWriteStore,
  ProjectionEntityStore,
} from '@soniq/public-resource'

export class InviteHttpStore extends HttpReadWriteStore<InviteSchema> {
  static new() {
    return new InviteHttpStore('invite', inviteSchema.validateFn)
  }
}

export class InviteProjectionStore extends ProjectionEntityStore<InviteSchema> {
  static new() {
    return new InviteProjectionStore('invite', inviteSchema)
  }
}
